import Layout from "../components/layout/Layout";
import Crew from "../pages/crew/Crew";
import Home from "../pages/home/Home";
import VisualNarratives from "../pages/visualNarratives/VisualNarratives";
import AuditoryNarratives from "../pages/auditoryNarratives/AuditoryNarratives";
import TextualNarratives from "../pages/textualNarratives/TextualNarratives";
import AboutUs from "../pages/aboutUs/AboutUs";

const Routes = () => {
  return [
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/home",
          element: <Home />,
        },
        {
          path: "/visualnarratives",
          element: <VisualNarratives />,
        },
        {
          path: "/auditorynarratives",
          element: <AuditoryNarratives />,
        },
        {
          path: "/textualnarratives",
          element: <TextualNarratives />,
        },
        {
          path: "/crew",
          element: <Crew />,
        },
        {
          path: "/about",
          element: <AboutUs />,
        },
      ],
    },
  ];
};

export default Routes;
